import _ from "lodash"
import bookingPresetApi from '@/apis/liff/v2/booking-preset';
import collectionApi from "@/apis/liff/v2/collection"
import BookingPresetDataModel from "@/models/BookingPreset.model";
import BookingBusinessLogic from "@/utils/booking/BookingBusinessLogic";
import ServiceDataFetcher from "@/utils/booking/ServiceDataFetcher";
import OccupancyChecker from "@/utils/booking/OccupancyChecker"
import StaffDataFetcher from "@/utils/booking/StaffDataFetcher"

const bookingBusinessLogic = new BookingBusinessLogic()
const serviceDataFetcher = new ServiceDataFetcher()
serviceDataFetcher.injectCollectionApi(collectionApi)
const staffDataFetcher = new StaffDataFetcher()
staffDataFetcher.injectBookingPresetApi(bookingPresetApi)

// this store handles "wizard mode" of booking
export default {
  namespaced: true,
  state: {
    bookingPreset: null,
    branchIdOfBookingPreset: null,
    configurationIsValid: true,
    availableServices: [],
    availableStaffs: [],
    selectedBranch: {
      id: null,
      name: null,
    },
    selectedStaff: {
      id: null,
      name: null,
      img: null,
    },
    selectedServiceIds: [],
    selectedSchedule: {
      start_at: null,
    },
    selectedScheduleLabel: null,
    extraFormData: {},
    occupancyChecker: null,
    submittedBooking: null,
    ongoingFetchBookingPresetPromise: null,
  },
  getters: {
    selectedServices(state) {
      return state.availableServices.filter((service) => state.selectedServiceIds.includes(service.id))
    },
  },
  actions: {
    async fetchBookingPreset(context, { bookingPresetId, branchId = null }) {
      if (context.state.bookingPreset?.id == bookingPresetId && context.state.branchIdOfBookingPreset == branchId) {
        return context.state.bookingPreset
      }

      if (context.state.ongoingFetchBookingPresetPromise) {
        // used to prevent multiple concurrent requests
        return context.state.ongoingFetchBookingPresetPromise
      }

      const fetchPromise = (async () => {
        try {
          const bookingPresetResponse = await bookingPresetApi.get(bookingPresetId, {
            branch_id: branchId
          })
          context.state.bookingPreset = bookingPresetResponse
          context.state.branchIdOfBookingPreset = branchId

          if (true === _.get(bookingPresetResponse, 'config.occupy_config.enable', false)) {
            const occupancyChecker = new OccupancyChecker(bookingPresetResponse.id, _.get(bookingPresetResponse, 'config.occupy_config'))
            occupancyChecker.setLastConditionType('time')
            occupancyChecker.receiveShop(branchId)
            context.state.occupancyChecker = occupancyChecker
          }

          return bookingPresetResponse
        } finally {
          context.state.ongoingFetchBookingPresetPromise = null
        }
      })()

      context.state.ongoingFetchBookingPresetPromise = fetchPromise
      return fetchPromise
    },
    validateBookingPreset(context, bookingPreset) {
      try {
        (new BookingPresetDataModel(bookingPreset)).validateWizardConfiguration()
        context.state.configurationIsValid = true
      } catch (error) {
        context.state.configurationIsValid = false
        throw error
      }
    },
    async fetchServices({ state }, { bookingPreset, branchId, staffId }) {
      const dataModel = new BookingPresetDataModel(bookingPreset)
      bookingBusinessLogic.setBookingPresetDataModel(dataModel)
      serviceDataFetcher.setServiceFieldMappings(dataModel.serviceFieldMappings)
      if (bookingBusinessLogic.servicesAreBoundToBranches() && branchId) {
        await serviceDataFetcher.fetchServicesByBranch(dataModel.collectionIdForService, branchId)
      } else if (bookingBusinessLogic.servicesAreBoundToStaffs() && staffId) {
        await serviceDataFetcher.fetchServicesByStaff(dataModel.collectionIdForService, staffId)
      } else {
        await serviceDataFetcher.fetchServices(dataModel.collectionIdForService)
      }
      state.availableServices = serviceDataFetcher.services
    },
    async fetchAvailableStaffs({ state }, { serviceIds, branchId, bookingPresetId }) {
      state.availableStaffs = []
      state.availableStaffs = await staffDataFetcher.fetchAvailableStaffs(serviceIds, branchId, bookingPresetId)
    },
    selectBranch(context, branch) {
      context.state.selectedBranch = branch
      _.invoke(context.state.occupancyChecker, 'receiveShop', branch.id)
    },
    selectStaff(context, staff) {
      context.state.selectedStaff = staff
      _.invoke(context.state.occupancyChecker, 'receiveStaff', staff.id)
    },
    selectService(context, serviceIds) {
      context.state.selectedServiceIds = Array.isArray(serviceIds) ? serviceIds : [serviceIds]
      _.invoke(context.state.occupancyChecker, 'receiveService', serviceIds)
    },
    selectSchedule(context, schedule) {
      context.state.selectedSchedule = schedule
    },
    selectScheduleLabel(context, scheduleLabel) {
      context.state.selectedScheduleLabel = scheduleLabel
    },
    setExtraFormData(context, extraFormData) {
      context.state.extraFormData = extraFormData
    },
    async setSubmittedBooking({ state }, booking) {
      state.submittedBooking = booking
    },
  },
}
